import { useFeatureFlag } from './useFeatureFlag';

type Props<T> = {
  recaptcha: T;
  featureFlag: 'web.login_challenge' | 'web.signup_challenge';
};

export function useWebLoginChallenge<T>({ recaptcha, featureFlag }: Props<T>) {
  const flag = useFeatureFlag(featureFlag);

  switch (flag) {
    case 'recaptcha': {
      return recaptcha;
    }
    case undefined:
      return undefined;
    case false:
      return null;
  }
}
